import { configureStore } from "@reduxjs/toolkit";
import customizationReducer from "features/customization/customizationSlice";

export const store = configureStore({
  reducer: {
    customization: customizationReducer,
  },
});
